<script>
import appConfig from "@/app.config";
import CustomersApi from "@/services/customers-api";
import InvoicesApi from "@/services/invoices-api";
import Swal from 'sweetalert2';

export default {
  page: {
    title: "BeingValidationInvoices",
    meta: [{ name: "description", content: appConfig.description }]
  },

  data() {
    return {
      customersList: [],
      beingValidationInvoices: [],
      selected: null,
      selectedCustomer: null,
      end: null,

      pagemodel: {
        currentPage: 1,
        perPage: 10,
        totalRows: 0
      },

      isLoadingInvoices: false,
      agencySelected: null,
      lastValidationDate: null,

      fields: [
        { key: "date", label: "Date", tdClass: "font-weight-bold" },
        { key: "number", label: "Numéro" },
        { key: "customerExtId", label: "Code", tdClass: "font-weight-bold" },
        { key: "customer", label: "Client", tdClass: "font-weight-bold", thStyle: { minWidth: "200px" } },
        { key: "company", label: "Type", tdClass: "font-weight-bold" },
        { key: "totalWithTaxes", label: "Total TTC (TND)", tdClass: "text-right", thClass: "text-right", thStyle: { minWidth: "150px" } },
      ]
    };
  },

  computed: {
    role() {
      return this.$cookies.get("userr");
    },
    isAdmin() {
      return this.$cookies.get("userr") == 1;
    },

    agencyList() {
      try {
        return JSON.parse(process.env.VUE_APP_FEATURE_AGENCY_LIST || "[]");
      } catch (e) {
        return [];
      }
    },

    filterByAgency() {
      return this.agencyList && this.agencyList.length > 1;
    },
    isAgencySupplier() {
      return this.$cookies.get('iss');
    },

  },

  mounted() {

    if(this.isAdmin && !this.isAgencySupplier){
      this.agencySelected = this.agencyList.length > 0 ? this.agencyList[0] : null;
    }

    if (this.isAdmin) {
      this.getCustomers();
      this.getBeingValidationInvoices();
      this.findLastValidationDate();
    }
  },

  methods: {


    confirmValidateAllInvoices() {
      if (!this.end) {
        Swal.fire('Erreur', 'Veuillez sélectionner une date de fin.', 'error');
        return;
      }

      const formattedEndDate = this.end ? new Date(this.end).toLocaleDateString('fr-FR') : '';

      Swal.fire({
        title: 'Confirmer la validation',
        html: `Vous êtes sur le point de valider toutes les factures avant le <span class="font-weight-bold text-primary">${formattedEndDate}</span> pour <span class="font-weight-bold text-dark text-uppercase">tous les clients.</span> <br/> Cette action est irréversible. Confirmez-vous ?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Oui, valider !',
        cancelButtonText: 'Annuler',
      }).then((result) => {
        if (result.isConfirmed) {
          this.validateAllInvoices();
        }
      });
    },




    findLastValidationDate() {
      InvoicesApi.findLastValidationDate().then(result => {
        if (result && result.value) {
          this.lastValidationDate = result.value;
        }
      });
    },

    validateAllInvoices(){
        this.selectedCustomer = null;
        InvoicesApi.validateAllInvoices(this.end, this.agencySelected ? this.agencySelected.id : null).then((result) => {
            this.beingValidationInvoices=result.list;
            this.pagemodel.totalRows = result.total;
            this.pagemodel.currentPage = result.page;
            this.pagemodel.perPage = result.pageSize;
            this.pagemodel.pageSize = result.pageSize;

            Swal.fire('Succès', 'Toutes les factures ont été validées avec succès.', 'success');

            this.findLastValidationDate();
        }).catch(() => {
            Swal.fire('Erreur', 'Une erreur est survenue lors de la validation des factures.', 'error');
        });
    },



    getCustomers() {
      CustomersApi.getCustomers(null, null).then(response => {
        if (response && response.length > 0) {
          this.customersList = response;
        }
      });
    },

    getBeingValidationInvoices() {
      this.isLoadingInvoices = true;
      InvoicesApi.getBeingValidationInvoices(this.pagemodel.currentPage, this.pagemodel.perPage,
        this.selectedCustomer, this.agencySelected ? this.agencySelected.id : null)
      .then(result => {
        this.beingValidationInvoices=result.list;
        this.pagemodel.totalRows = result.total;
        this.pagemodel.currentPage = result.page;
        this.pagemodel.perPage = result.pageSize;
        this.pagemodel.pageSize = result.pageSize;

      })
      .finally(() => {
        this.isLoadingInvoices = false;
      });
    },
    
  },

  watch: {
    selected(newVal) {
      this.selectedCustomer = newVal ? newVal.id : null;
      this.getBeingValidationInvoices();
    },

    agencySelected() {
      this.getBeingValidationInvoices();
    }
  }
};
</script>
<template>
  <div>

    <div class="row mt-2 align-items-end">

      <div v-if="isAdmin" class="col-md-3" >
        <b-form-group
        :label="$t('lists.customers.filter')"
        label-for="customer-filter"
        >
        <v-select
            id="customer-filter"
            class="style-vselect-big"
            style="font-size:1.2em;"
            :options="customersList"
            :placeholder="$t('lists.customers.label')"
            label="fullCompanyName"
            v-model="selected"
        >
            <span slot="no-options">
            {{$t('lists.emptyLists.label')}}
            </span>
        </v-select>
        </b-form-group>
    </div>

      <div v-if="isAdmin" class="col-md-3">

        <b-form-group v-if="this.filterByAgency  && !isAgencySupplier"
        :class="filterByAgency ? 'ml-md-3 ml-0' : 'mr-0'"
        :label="$t('lists.agency.filter')"
        label-for="agency-filter"
        >
        <v-select
            id="agency-filter"
            class="style-vselect-big"
            style="font-size:1.2em;"
            :options="agencyList"
            :placeholder="$t('lists.agency.label')"
            label="name"
            v-model="agencySelected"
        >
            <span slot="no-options">
            {{$t('lists.emptyLists.label')}}
            </span>
        </v-select>
        </b-form-group>

      </div>


    <!-- Right side controls -->
    <div :class="filterByAgency ? 'col-md-6' : 'col-md-9'">
        <div class="d-flex justify-content-end align-items-end flex-wrap">

        <!-- Date Picker -->
        <b-form-group
            class="mb-0 mr-md-3 mr-0"
            :label="$t('datPicker.validationDate.label-no-date-selected')"
            label-for="end-date-picker"
        >
            <b-form-datepicker
            id="end-date-picker"
            v-model="end"
            :locale="$t('datPicker.locale')"
            :label-no-date-selected="$t('datPicker.validationDate.label-no-date-selected')"
            dark
            reset-button
            close-button
            :label-reset-button="$t('datPicker.label-reset-button')"
            :label-close-button="$t('datPicker.label-close-button')"
            dropright
            hide-header
            />
        </b-form-group>

        <!-- Button -->
        <b-button
            variant="primary"
            @click="confirmValidateAllInvoices"
            :disabled="!end || isLoadingInvoices"
            class="mb-0 mt-md-0 mt-2"
        >
            <i class="fas fa-check-circle mr-2"></i>
            Valider Facture
        </b-button>

        </div>


          <div v-if="lastValidationDate" class="mt-2 text-right">
              <small class="text-muted">Dernière validation effectuée le {{ lastValidationDate }}</small>
          </div>
    </div>

    </div>

    <div class="table-responsive mb-0 mt-5 " style="max-height:40em;min-height:31em">

        <b-table
            :busy="isLoadingInvoices"
            :items="beingValidationInvoices"
            :fields="fields"
            striped
            hover
            small
            >
        <template v-slot:table-busy>
            <div class="text-center my-2">
                <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
            </div>
        </template>

        <template v-slot:cell(company)="{item}">  
            <h5>
                <b-badge :variant="item.company === 'PARA' ? 'success' : 'info'">
                    {{ item.company }}
                </b-badge>
            </h5>
        </template>


        </b-table>
        <span v-if="!beingValidationInvoices && !beingValidationInvoices.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("reporting.supplier.emptyTable") }} </span>

    </div>

    <div  class="row pt-3 mb-sm-4">
        <div class="col-sm-8">
            <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                <b-form-select
                    v-model="pagemodel.perPage"
                    @input="getBeingValidationInvoices" 
                    size="sm"
                    style="width: 60px"
                    :options="[10,20,30,60]"
                ></b-form-select>
                <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{$t('pagination.from')}}</span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{$t('pagination.lines')}}</span></div>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                <b-pagination
                    v-model="pagemodel.currentPage"
                    @input="getBeingValidationInvoices"
                    :per-page="pagemodel.perPage"
                    :total-rows="pagemodel.totalRows"
                    ></b-pagination>
                </ul>
            </div>
        </div>
    </div>

  </div>
</template>

<style>
/* Keeping v-select style, but no longer scoped if it's the only one */
.style-vselect .vs__search {
  line-height: 1;
  color: #394066;
  font-size: 1em;
}

/* Ensure style-vselect-big also works if used by the customer select */
.style-vselect-big .vs__search::placeholder,
.style-vselect-big .vs__dropdown-toggle,
.style-vselect-big .vs__search,
.style-vselect-big .vs__dropdown-menu {
  line-height: 1.6;
  font-size: 1em;
  background: white;
}

.style-vselect-big .vs__clear,
.style-vselect-big .vs__open-indicator {
  fill: #000;
}
</style>